// extracted by mini-css-extract-plugin
export default {"why_row":"WhyChooseUs_why_row__8Snd0","info":"WhyChooseUs_info__zUhZV","badge":"WhyChooseUs_badge__tS05o"};